/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_ContentInputs */

const vi_media_field_content = /** @type {(inputs: Media_Field_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung`)
};

/**

* @param {Media_Field_ContentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_content = /** @type {((inputs?: Media_Field_ContentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_ContentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_content(inputs)
});